import strings from 'utils/strings'
import {
  CHECPLUS_MODULE_TYPES,
  CHECPLUS_MODULE_NAMES,
  MODULES,
} from 'utils/constants'
import { MODULE_NAME_INTERFACE } from 'constants/ecus'
import { mapFrom } from 'utils/functional'

const checPlusModuleNames = {
  [CHECPLUS_MODULE_NAMES.ASAM]: strings.asam,
  [CHECPLUS_MODULE_NAMES.XMC1]: strings.xmc1,
  [CHECPLUS_MODULE_NAMES.XMC2]: strings.xmc2,
  [CHECPLUS_MODULE_NAMES.XMC3]: strings.xmc3,
  [CHECPLUS_MODULE_NAMES.XMC4]: strings.xmc4,
  [CHECPLUS_MODULE_NAMES.XMC5]: strings.xmc5,
  [CHECPLUS_MODULE_NAMES.XMC6]: strings.xmc6,
  [CHECPLUS_MODULE_NAMES.XMC7]: strings.xmc7,
  [CHECPLUS_MODULE_NAMES.XMC8]: strings.xmc8,
  [MODULE_NAME_INTERFACE]: strings.interface_connectors,
}
const m2ModuleNames = {
  [MODULES.BHM]: strings.bulkhead_module,
  [MODULES.CHM]: strings.chassis_module,
  [MODULES.DASH_O]: strings.recreational_vehicle_module,
  [MODULES.EXM1]: strings.expansion_one,
  [MODULES.EXM2]: strings.expansion_two,
  [MODULES.EXM3]: strings.expansion_three,
}

const moduleNames = {
  [CHECPLUS_MODULE_TYPES.XMC]: strings.xmc,
  ...checPlusModuleNames,
  ...m2ModuleNames,
}
export default mapFrom(moduleNames)
